import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Switch } from "../components/ui/switch";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../lib/auth";
import { PageHeader } from "../components/app/PageHeader";

export default function Users() {
  const { user: me } = useAuth();
  const [data, setData] = useState(null);
  const [gkks, setGkks] = useState([]);
  const load = () => api.get("/users").then((r) => setData(r.data));
  useEffect(() => { load(); api.get("/gkks").then((r) => setGkks(r.data)); }, []);

  const update = async (u, body) => {
    try { await api.patch(`/users/${u.user_id}`, body); toast.success("Updated"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <PageHeader eyebrow="Access control" title="Users & Roles" testId="users-header">
        Everyone who signs in starts as a Parishioner with no access to private records. Assign roles only to people with a legitimate pastoral responsibility. GKK Presidents see only their own GKK. Deactivating an account signs it out immediately.
      </PageHeader>
      <div className="overflow-x-auto rounded-xl border border-amber-700/15 bg-white p-5">
        <table className="w-full text-sm" data-testid="users-table">
          <thead><tr className="text-left text-stone-500"><th className="py-2">Name</th><th>Email</th><th>Role</th><th>GKK (for GKK Presidents)</th><th>Active</th></tr></thead>
          <tbody>
            {data?.users.map((u) => {
              const locked = u.user_id === me.user_id;
              return (
                <tr key={u.user_id} className="border-t border-amber-700/10" data-testid={`user-row-${u.user_id}`}>
                  <td className="py-3 font-semibold text-stone-800">{u.name}</td>
                  <td className="text-stone-600">{u.email}</td>
                  <td className="min-w-[220px]">
                    <Select value={u.role} disabled={locked} onValueChange={(v) => update(u, { role: v })}>
                      <SelectTrigger className="bg-white" data-testid={`role-select-${u.user_id}`}><SelectValue /></SelectTrigger>
                      <SelectContent className="bg-white">{Object.entries(data.roles).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}</SelectContent>
                    </Select>
                  </td>
                  <td className="min-w-[180px]">
                    <Select value={u.gkk_id || "none"} disabled={locked} onValueChange={(v) => update(u, { gkk_id: v === "none" ? "" : v })}>
                      <SelectTrigger className="bg-white" data-testid={`gkk-select-${u.user_id}`}><SelectValue /></SelectTrigger>
                      <SelectContent className="bg-white"><SelectItem value="none">None</SelectItem>{gkks.map((g) => <SelectItem key={g.gkk_id} value={g.gkk_id}>{g.name}</SelectItem>)}</SelectContent>
                    </Select>
                  </td>
                  <td><Switch checked={u.active !== false} disabled={locked} onCheckedChange={(v) => update(u, { active: v })} data-testid={`active-switch-${u.user_id}`} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
